import React from "react";
import { SvgIcon } from "@mui/material";
import type { SvgIconProps } from "@mui/material";
import { ReactComponent as OctopusManagerSvg } from "../../resources/images/svgs/octopus_manager.svg";

export function OctopusMangerLogo(props: Partial<SvgIconProps>) {
  return <SvgIcon {...props} component={OctopusManagerSvg} viewBox="0 0 216 216" />;
}
